<template>
	<Loader v-if="loading"/>
    <div class="confirm-email-overlay" :class="popupType=='soft' ? 'soft-login' : 'hard-login'" v-if="displayConfPopup">
		<div class="auth-popup-close" @click="updateConfirmationPopup">
				<img src="../assets/cancel.svg" alt="close"/>
		</div>
        <WebmdDialog
			:close-on-click-modal="false"
			:close-on-press-escape="true"
            title=""
            :visible.sync="displayConfPopup"
            height="100%"
            width="100%"
			:show-close="false"
            background="#FFFFFF"
            opacity="1"
			:before-close="closePopup"
        >
            <div class="overlay-cont">
                <svg width="130" height="108" viewBox="0 0 410 449" fill="none" xmlns="http://www.w3.org/2000/svg" class="mail-img">
					<path d="M337.19 76.97C333.69 75.78 331.55 75.19 331.53 75.18L332.06 73.25C332.15 73.27 334.28 73.86 337.84 75.07L337.19 76.96V76.97Z" fill="#7484D8"/>
					<path d="M182.231 315.93C180.731 312.15 179.601 308.12 178.861 303.94L180.831 303.59C181.541 307.63 182.641 311.53 184.091 315.19L182.231 315.93ZM179.811 291.56H177.811C177.811 287.56 178.131 283.4 178.761 279.19L180.741 279.48C180.131 283.59 179.821 287.65 179.811 291.55V291.56ZM183.281 267.62L181.351 267.09C182.411 263.26 183.731 259.31 185.261 255.36L187.121 256.08C185.611 259.96 184.321 263.85 183.271 267.61L183.281 267.62ZM192.021 244.93L190.221 244.05C191.961 240.47 193.911 236.81 196.011 233.16L197.741 234.16C195.661 237.77 193.741 241.39 192.011 244.93H192.021ZM204.151 223.77L202.481 222.67C204.661 219.34 207.021 215.93 209.491 212.54L211.111 213.72C208.661 217.08 206.321 220.46 204.161 223.76L204.151 223.77ZM357.751 210.8H357.161L357.181 208.8H357.751C361.781 208.8 365.591 208.34 369.071 207.44L369.571 209.38C365.921 210.33 361.951 210.81 357.751 210.81V210.8ZM344.801 209.53C341.121 208.86 337.181 207.92 332.771 206.67L333.321 204.75C337.661 205.99 341.541 206.91 345.161 207.57L344.801 209.54V209.53ZM218.841 204.41L217.401 203.02C220.401 199.93 223.581 197.21 226.861 194.94L228.001 196.58C224.831 198.78 221.751 201.41 218.841 204.41ZM381.031 204.34L379.941 202.66C383.131 200.59 386.151 197.94 388.911 194.78L390.421 196.1C387.531 199.4 384.371 202.18 381.031 204.34ZM321.011 202.96C317.681 201.83 314.321 200.65 310.931 199.46L309.401 198.92L310.061 197.03L311.591 197.57C314.961 198.76 318.321 199.93 321.641 201.06L321.001 202.95L321.011 202.96ZM297.821 194.94C293.481 193.51 289.651 192.34 286.131 191.37L286.661 189.44C290.211 190.42 294.071 191.59 298.451 193.04L297.821 194.94ZM238.571 190.89L237.841 189.03C241.651 187.53 245.701 186.45 249.891 185.83L250.181 187.81C246.141 188.41 242.241 189.44 238.571 190.89ZM274.271 188.63C269.991 187.86 266.051 187.4 262.231 187.23L262.321 185.23C266.231 185.4 270.261 185.86 274.631 186.66L274.271 188.63ZM397.601 185.93L395.871 184.93C397.761 181.68 399.551 178.01 401.211 174.04L403.061 174.81C401.371 178.86 399.531 182.6 397.601 185.93ZM407.131 163.1L405.191 162.59C406.241 158.57 406.891 154.57 407.121 150.7L409.121 150.82C408.891 154.82 408.221 158.96 407.131 163.11V163.1ZM406.451 138.72C405.771 134.82 404.611 130.95 403.001 127.23L404.841 126.44C406.511 130.3 407.711 134.32 408.421 138.38L406.451 138.72ZM397.091 116.75C394.871 113.59 392.251 110.48 389.301 107.5L390.721 106.09C393.741 109.15 396.431 112.34 398.721 115.59L397.091 116.74V116.75ZM380.211 99.46C377.141 97.07 373.781 94.73 370.231 92.51L371.291 90.81C374.901 93.07 378.321 95.45 381.441 97.88L380.211 99.46ZM359.621 86.5C356.081 84.68 352.361 82.94 348.561 81.33L349.341 79.49C353.181 81.12 356.941 82.88 360.531 84.72L359.621 86.5Z" fill="#7484D8"/>
					<path d="M192.2 331.8C192.13 331.74 190.43 330.18 188.21 327.05L189.84 325.89C191.92 328.82 193.53 330.3 193.55 330.32L192.2 331.8Z" fill="#7484D8"/>
					<path d="M319.091 71.2L287.491 63.65L280.991 79.11L201.101 36.68L320.451 0L302.121 32.84L319.091 71.2Z" fill="#3557FF"/>
					<path d="M319.091 71.2L293.011 48.45L201.101 36.68L302.121 32.84L319.091 71.2Z" fill="#1C3DB5"/>
					<path d="M287.49 63.6501L293.01 48.4501L319.09 71.2001L287.49 63.6501Z" fill="#000625"/>
					<path d="M39.3304 281.53L172.45 186.97C175.22 185 179.77 184.98 182.56 186.92L316.56 280.23C320.67 283.09 322.94 286.75 322.96 290.55L323.3 362.56L33.3704 363.91L33.0304 291.9C33.0104 288.1 35.2504 284.42 39.3304 281.52V281.53Z" fill="#D2B447"/>
					<path d="M299.038 129.826L55.4608 130.974C49.938 131 45.482 135.498 45.5081 141.021L46.838 423.248C46.8641 428.771 51.3623 433.227 56.885 433.201L300.462 432.053C305.985 432.027 310.441 427.528 310.415 422.006L309.085 139.779C309.059 134.256 304.561 129.8 299.038 129.826Z" fill="#F8F8F8"/>
					<path d="M163.168 144.619L69.3386 145.062C65.8924 145.078 63.1118 147.885 63.128 151.331L63.1281 151.341C63.1443 154.787 65.9512 157.568 69.3974 157.551L163.226 157.109C166.673 157.093 169.453 154.286 169.437 150.84L169.437 150.83C169.421 147.384 166.614 144.603 163.168 144.619Z" fill="#6CE3BF"/>
					<path d="M285.446 178.183L69.4982 179.2C66.052 179.217 63.2715 182.023 63.2877 185.47L63.2878 185.48C63.304 188.926 66.1109 191.706 69.5571 191.69L285.505 190.673C288.951 190.656 291.731 187.849 291.715 184.403L291.715 184.393C291.699 180.947 288.892 178.166 285.446 178.183Z" fill="#EDF0FF"/>
					<path d="M285.584 205.392L69.6364 206.409C66.1902 206.426 63.4096 209.233 63.4259 212.679L63.4259 212.689C63.4422 216.135 66.249 218.916 69.6953 218.899L285.643 217.882C289.089 217.865 291.87 215.059 291.853 211.612L291.853 211.602C291.837 208.156 289.03 205.376 285.584 205.392Z" fill="#EDF0FF"/>
					<path d="M285.712 232.601L69.7644 233.619C66.3181 233.635 63.5376 236.442 63.5538 239.888L63.5539 239.898C63.5701 243.344 66.377 246.125 69.8232 246.108L285.771 245.091C289.217 245.075 291.998 242.268 291.981 238.821L291.981 238.811C291.965 235.365 289.158 232.585 285.712 232.601Z" fill="#EDF0FF"/>
					<path d="M285.831 259.81L69.883 260.828C66.4368 260.844 63.6562 263.651 63.6725 267.097L63.6725 267.107C63.6888 270.553 66.4956 273.334 69.9418 273.318L285.889 272.3C289.336 272.284 292.116 269.477 292.1 266.031L292.1 266.021C292.084 262.574 289.277 259.794 285.831 259.81Z" fill="#EDF0FF"/>
					<path d="M285.969 287.019L70.0212 288.037C66.575 288.053 63.7944 290.86 63.8107 294.306L63.8107 294.316C63.8269 297.762 66.6338 300.543 70.08 300.527L286.028 299.509C289.474 299.493 292.254 296.686 292.238 293.24L292.238 293.23C292.222 289.783 289.415 287.003 285.969 287.019Z" fill="#EDF0FF"/>
					<path d="M286.097 314.228L70.1491 315.246C66.7029 315.262 63.9223 318.069 63.9386 321.515L63.9386 321.525C63.9549 324.971 66.7618 327.752 70.208 327.736L286.156 326.718C289.602 326.702 292.382 323.895 292.366 320.449L292.366 320.439C292.35 316.993 289.543 314.212 286.097 314.228Z" fill="#EDF0FF"/>
					<path d="M286.226 341.447L70.278 342.465C66.8318 342.481 64.0513 345.288 64.0675 348.734L64.0675 348.744C64.0838 352.19 66.8906 354.971 70.3369 354.955L286.284 353.937C289.731 353.921 292.511 351.114 292.495 347.668L292.495 347.658C292.479 344.212 289.672 341.431 286.226 341.447Z" fill="#EDF0FF"/>
					<path d="M178.37 362.17L309.76 284.73C315.58 281.3 322.93 285.48 322.96 292.23L323.64 437.23C323.66 442.07 319.76 446 314.92 446.03L42.5904 447.3C37.7504 447.32 33.8204 443.42 33.7904 438.58L33.1104 293.58C33.0804 286.82 40.3904 282.58 46.2404 285.95L178.35 362.16L178.37 362.17Z" fill="#FCD859"/>
					<g style="mix-blend-mode:soft-light" opacity="0.2">
					<path d="M37.5803 430.54L172.96 326.37C176.03 324.01 180.18 323.99 183.26 326.32L319.61 429.22C327.16 434.92 323.13 446.87 313.65 446.92L43.6903 448.18C34.2103 448.22 30.0703 436.31 37.5703 430.54H37.5803Z" fill="black"/>
					</g>
					<path d="M37.6704 431.42L173.08 332.4C176.15 330.16 180.3 330.14 183.38 332.35L319.71 430.1C327.26 435.51 323.23 446.87 313.75 446.92L43.7904 448.18C34.3104 448.22 30.1804 436.9 37.6704 431.42Z" fill="#FEF3CD"/>
					<path d="M44.1502 185.8C68.4121 185.8 88.0802 166.132 88.0802 141.87C88.0802 117.608 68.4121 97.9401 44.1502 97.9401C19.8883 97.9401 0.220215 117.608 0.220215 141.87C0.220215 166.132 19.8883 185.8 44.1502 185.8Z" fill="#3557FF"/>
					<path d="M21.1804 144.35C21.1804 128.41 32.9004 117.88 46.9104 117.88C59.2504 117.88 67.1104 126.27 67.1104 138.22C67.1104 148.65 60.1104 153.88 54.1304 153.88C50.8304 153.88 48.1504 152.32 47.5404 149.54H47.4304C45.8504 151.8 42.9104 153.35 40.5604 153.35C36.1004 153.35 33.0404 149.99 33.0404 144.76C33.0404 137.8 38.0304 130.78 44.5704 130.78C46.4404 130.78 47.9404 131.6 48.8904 133.61H49.0004L49.8304 131.23H54.9804L52.3804 143.8C51.5704 147.11 52.4504 148.7 54.9804 148.7C58.4404 148.7 61.8004 144.68 61.8004 138.42C61.8004 130.26 57.4004 122.95 46.2004 122.95C36.4504 122.95 26.8104 131.29 26.8104 144.13C26.8104 155.39 34.6004 160.77 43.4804 160.77C46.4204 160.77 49.7804 159.82 52.1504 158.58L53.9804 163.15C50.5004 165.02 46.8704 165.85 42.8004 165.85C31.3804 165.85 21.1504 158.92 21.1504 144.34L21.1804 144.35ZM46.1604 145.5L47.5204 137.79C46.9304 136.73 46.0204 136.14 44.8604 136.14C41.4704 136.14 39.3804 140.85 39.3804 144.27C39.3804 146.81 40.5104 148.08 42.3904 148.08C43.5804 148.08 44.7104 147.39 46.1704 145.5H46.1604Z" fill="white"/>
				</svg>

                <b>Please Verify Your Email Address.</b>
                <p>An email has been sent to {{ userEmail }} with a link to click and verify.</p>
                <p>Don't see it? Try checking your spam folder.</p>
                <p v-if="!this.successMsg">Didn't get an email? <a href="javascript:void(0)" @click="resendEmail()">Resend</a></p>
                <p v-if="this.successMsg" class="success-msg">
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.5 0.854858C6.11553 0.854858 4.76216 1.2654 3.61101 2.03457C2.45987 2.80374 1.56266 3.89699 1.03285 5.17607C0.503033 6.45516 0.36441 7.86262 0.634506 9.22049C0.904603 10.5784 1.57129 11.8256 2.55026 12.8046C3.52922 13.7836 4.7765 14.4503 6.13437 14.7204C7.49224 14.9905 8.8997 14.8518 10.1788 14.322C11.4579 13.7922 12.5511 12.895 13.3203 11.7438C14.0895 10.5927 14.5 9.23933 14.5 7.85486C14.5 5.99834 13.7625 4.21787 12.4497 2.90511C11.137 1.59236 9.35652 0.854858 7.5 0.854858ZM6.5 10.6499L4 8.14986L4.795 7.35486L6.5 9.05986L10.205 5.35486L11.003 6.14786L6.5 10.6499Z" fill="#117A49"/>
                    </svg>
                    We sent you a new link!</p>
                <p v-if="!this.successMsg && this.errorEmailMsg" class="text-error">Sorry something went wrong.Please retry again!</p>
                <p>Already verified? <a href="javascript:void(0)"  @click="getUserInfo()" >Refresh</a></p>
                <p><a @click="contctOmniCall()" href="https://customercare.webmd.com/hc/en-us" target="_blank"> Contact support</a></p>
            </div>
        </WebmdDialog>
    </div>
</template>

<script>
import {Dialog } from 'webmd-elements';
import axios from 'axios';
import api from '../api.es6';
import registrationMixins from './mixins/registration.mixins.es6';
import commonapiMixins from './mixins/commonapi.mixins.es6';
import Loader from './Loader.vue'
export default {
	name:'Login',
	components:{
		Loader,
		WebmdDialog: Dialog,
	},
    props:{
        displayPopup : Boolean,
        popupType : String,
		userEmail : String,
		userId : String,
		pageName : String,
		savedAccessToken : String,
		contentData:Object,
		savedDrugs:Object
    },
	watch:{
		displayPopup(newVal){
			this.addClassToModal()
			this.removeOverlay()
			this.udpateClassPopup(newVal)
		}
	},
	emits: ['closeAuthPopup', 'updateDisplay', 'logoutApp', 'updateAction', 'saveSuccess'],
	mixins: [registrationMixins, commonapiMixins],
	data() {
		return {
			loading : false,
			userMainID : '',
			displayConfPopup : false,
			successMsg: '',
			errorEmailMsg: false,
			accessToken : '',
		};
	},
	async mounted(){
		if(this.savedAccessToken){
			this.accessToken = this.savedAccessToken
		}
		this.addClassToModal()
		this.removeOverlay()
		await this.checkToken(true)
	},
	methods:{
		addClassToModal(){
			let getData = document.getElementsByClassName('v-modal');
			setTimeout(()=>{
				if(getData && getData.length){
					getData[0].classList.add('auth-popup-mc-modal')
				}
			},1000)
			
		},
		removeOverlay(){
			let getData = document.getElementsByClassName('v-modal');
			if(getData && getData.length){
				document.getElementsByClassName('v-modal')[0].remove()
			}

			let getHolderCLass = document.getElementsByClassName('webmd-popup-parent--hidden');
			if(getHolderCLass && getHolderCLass.length){
				document.getElementsByClassName('webmd-popup-parent--hidden')[0].classList.remove('webmd-popup-parent--hidden')
			}

			let getHolderPadding = document.getElementsByClassName('vn-scrim');
			if(getHolderPadding && getHolderPadding.length){
				document.getElementsByClassName('vn-scrim')[0].style.removeProperty('padding-right')
			}
		},
		closePopup(){
			this.$emit('closeAuthPopup')
		},
		updateConfirmationPopup(){
			this.$emit('updateDisplay', false)
			this.removeOverlay()
		},
		
		closeProfile(){
			this.$vwmdTrack({ sSource: `reg-email-ver_close` });
			this.$emit('logoutApp')
		},
		contctOmniCall() {
			this.$vwmdPageLink({moduleName: `reg-email-ver_csprt`});
		},
		udpateClassPopup(addClass=false){
			this.displayConfPopup = addClass
			this.addClassToModal()
		},
		getToken(authCode, initCall){
			let rememberMe = this.getCookie('WBMD_REM');
			let query = '/oauth2api.svc/token';
			let finalUrl = this.checkUrl('oauthapi',query);
			if(finalUrl){
				this.loading = true;
				api.getTokenHeaders().then(headers =>{
					const params = new URLSearchParams();
					params.append('grant_type', 'authorization_code');
					params.append('client_id', headers.headers.client_id);
					params.append('client_secret', headers.headers.client_secret);
					params.append('code', authCode);
					params.append('long_live_token', rememberMe==1 ? true : false);
					return  axios.post(`${finalUrl}`, params, {'Content-Type':'application/x-www-form-urlencoded'})}).then((response) => {
					if(response.data && response.data.error==null){
						this.accessToken = response.data.access_token;
						let date = new Date();
						date.setSeconds(response.data.expires_in);
						document.cookie = `WBMD_AUTHP=${response.data.access_token}; expires=${date.toUTCString()}; path=/; domain=.webmd.com; SameSite=None; Secure=true`;
						if(initCall){
							this.resendEmail(true)
						}
					}
					this.loading = false;
				}).catch((error) => {
					this.loading = false;
					delete_cookie('WBMD_AUTHP')
				});
			}
		},
		async checkToken(initCall){
			let webmdAuth = this.getCookie('WBMD_AUTHC');
			let webmdProfileAuth = this.getCookie('WBMD_AUTHP');
			if(webmdAuth && webmdProfileAuth){
				if(initCall){
					this.resendEmail(true,2)
				}
			}
			else if(webmdAuth && initCall){
				await this.getToken(webmdAuth, initCall)
			}
		},

		resendEmail(isSubmit, checkType=0) {
			this.loading = true;
			let query = '/api/svcgateway/v2/member/profile/SendVerificationEmail';
			let searchapi = this.checkUrl('www',query);
			const userInfoVal = {
				'UserId': this.userId ? this.userId : (this.userMainID ? this.userMainID : ''),
				'AppId': '1',
				'ReturnUrl': this.$route.query.returl ? this.$route.query.returl : '',
			};
			if(!isSubmit) {
				this.$vwmdPageLink({ moduleName: `reg-email-ver_resend` });
			}
			api.getUserHeaders('', this.accessToken)
				.then(headers => axios.post(`${searchapi}`, userInfoVal, headers))
				.then((response) => {
					this.udpateClassPopup(true)
					if (response.status === 200) {
						if(!isSubmit) {
							this.successMsg = 'We sent you a new link!'
						}
					}
					this.loading = false;
				})
				.catch((error) => {
					this.udpateClassPopup(true)
					if(!isSubmit) {
						this.errorEmailMsg = true;
					}
					this.loading = false;
				});
				
		},

		getUserInfo() {
			let query = '/api/reg/regapi.svc/secure/json2/user';
			let searchapi = this.checkUrl('www',query);
			this.$vwmdPageLink({ moduleName: `reg-email-ver_refresh` });
			this.loading = true;
			api.getUserHeaders('', this.accessToken).then(headers => axios.get(`${searchapi}`, headers, {credentials: 'include'})).then(async (response) => {
				this.loading = false;
				this.userInfoRes = response.data;
				if (response.data.code == 1) {
					let userInfo = response.data.data.userinfo[0];
					debugger;
					if(userInfo.emailVerifiedField === 1) {
						
						let checkSave = await this.saveAfterAuth(this.accessToken, 'save', this.contentData, this.savedDrugs)
						if(checkSave && checkSave.data){
							this.$emit('updateAction', 'save');
							this.$emit('saveSuccess', true);
						}
					}
				}
			}).catch((error) => {
				this.loading = false;
			});
		},
	}
};
</script>
<style lang="scss">
.login-page > .hard-login > .auth-popup-close {
	display: block;
}

.profile-overlay > .hard-login > .auth-popup-close {
	display: block;
}

.register-page > .confirm-email-overlay > .auth-popup-close {
	display: block;
}

.confirm-email-overlay{
	.webmd-dialog__header{
		padding:0px;
	}
	.webmd-dialog{
		margin:0px;
		padding:0px;
		height: auto !important;
		-webkit-transform: translateY(-50%);
		transform: translateY(-50%);
		top: 50%;
		width: 100% !important;
		padding-top: 12rem;
		vertical-align: center;
		justify-content: center;
		background: #fff;
		opacity: 1;
		border-radius: 0;
		box-shadow: none;
		margin-top: 0 !important;
		@media(max-width: 767px) {
			padding-top:10rem;
		}
	}
	.webmd-dialog__wrapper {
		width: 100% !important;
		height: 100% !important;
		background: #fff;
		opacity: 1;
		z-index: 9999999 !important;
		position: absolute;
	}
	.overlay-cont {
		color: #000;
		font-size: 18px;
		text-align: center;
		p{
			color: #000;
			font-size: 18px;
			text-align: center;
		}
		a {
			color: #3557FF;
		}
		svg {
			margin: 0 auto;
			display: flex;
		}
		b {
			font-size: 20px;
			display: block;
   			width: 100%;
		}

		.mail-img {
			margin-bottom: 15px;
		}
	}
	.text-error {
		color: #cb0606 !important;
		font-size: 14px !important;
		font-family: "Source Sans Pro",Arial,sans-serif;
	}
	.success-msg{
		color: #096C3E !important;
		font-weight: 600 !important;
		svg {
			display: inline !important;
			position: relative;
			top: 2px;
		}
	}

}

.register-overlay > .webmd-dialog__wrapper >.webmd-dialog > .webmd-dialog__body,
.soft-login > .webmd-dialog__wrapper >.webmd-dialog > .webmd-dialog__body,
.hard-login > .webmd-dialog__wrapper >.webmd-dialog > .webmd-dialog__body{
	padding: 0;

	@media (max-width: 768px) {
		padding: 0 20px;
	}
	.overlay-cont {
		p:nth-child(3), p:nth-child(4), p:nth-child(6)  {
			margin: 25px 0 0;
			@media (max-width: 768px) {
				margin: 20px 0 0;
				font-size:16px
			}
		}
		p:nth-child(5) {
			margin: 30px 0 0;
			@media (max-width: 768px) {
				margin: 25px 0 0;
			}
		}
		p:nth-child(7)  {
			margin: 25px 0 0;
			@media (max-width: 768px) {
				margin: 20px 0 0;
			}
		}
		p:nth-child(5), p:nth-child(6), p:nth-child(7)  {
			font-size: 16px;
			@media (max-width: 768px) {
				font-size: 14px;
			}
		}
	}
}



.webmd-loading-mask.is-fullscreen{
	z-index: 9999999 !important;
}
.webmd-dialog__wrapper {
	width: 100% !important;
	height: 100% !important;
	background: #fff;
	opacity: 1;
	z-index: 9999999 !important;
}
.fix-topup{
	top:0px !important;
	height: 100%;
	transform: none !important;

}
</style>